import { render, staticRenderFns } from "./CarbonOffsetProcess.vue?vue&type=template&id=7b67c840&scoped=true"
import script from "./CarbonOffsetProcess.vue?vue&type=script&lang=js"
export * from "./CarbonOffsetProcess.vue?vue&type=script&lang=js"
import style0 from "./CarbonOffsetProcess.vue?vue&type=style&index=0&id=7b67c840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_17bc9983cdb7459b16429e97d92f86dc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b67c840",
  null
  
)

export default component.exports